import { axiosInstance } from './index';

export const fetchCustomers = async () => {
  const response = await axiosInstance.get('/customers');
  // Backend returns { customers: [...] }
  return response.data?.customers || [];
};
